import {SET_USER, REMOVE_USER} from './actions';

export const userDetails = (state ={}, action) => {
  switch (action.type) {

    case SET_USER:
      return {
        ...state,
        user: action.user
      };

    case REMOVE_USER:
      let clone = Object.assign({}, state);
      delete clone['user'];
      return clone;
    default:
      return state;
  }

};